'use client'

import { Text } from '@vinted/web-ui'
import { Suspense } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  underline?: boolean
}

const AdInfo = ({ underline }: Props) => {
  const translate = useTranslate('advertisements')

  return (
    <Suspense>
      <div className="slot-info" data-testid="slot-info" suppressHydrationWarning>
        <Text
          as="h4"
          type="caption"
          theme="muted"
          text={translate('advertisement')}
          underline={underline}
        />
      </div>
    </Suspense>
  )
}

export default AdInfo
